var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"specialist-menu sub-menu"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/search-specialist"}},[_vm._v("Search Availability")])],1),_c('li',{staticClass:"is-icon",on:{"click":_vm.getUrl}},[_vm._v("Download Referral Network")])]),_c('ExportSpecialistModal',{ref:"exportSpecialistsModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }